const updateBrandsForRegion = () => {
  let regionId = document.querySelector('#region-select').value
  let input = document.querySelector('#brand-select');
  let selected = input.value;

  fetch(`/regions/${regionId}.json`)
    .then(response => response.json())
    .then(data => {
      input.innerHTML = '';

      if(isAdmin()) {
        let blankOpt = document.createElement('option');
        blankOpt.text = 'Select Brand';
        blankOpt.value = '';
        input.appendChild(blankOpt);
      }

      data.brands.forEach(brand => {
        let opt = document.createElement('option');
        opt.text = brand;
        opt.value = brand;
        opt.selected = brand == selected;
        input.appendChild(opt);
      })
    });
}

function isAdmin() {
  // the tb core object will be defined
  return typeof tb !== 'undefined'
}

document.addEventListener('DOMContentLoaded', () => {
  let regionSelect = document.querySelector('#region-select');
  if (regionSelect) {
    regionSelect.addEventListener('change', updateBrandsForRegion);
  };
})
